import State from "@/helpers/pattern/state";
import { Massupdate } from "@/models/operativos/massupdate";
import { modelIsModified } from "@/helpers/vue-mc";
import campanaAPI from "@/services/operativos/campana";
import CombosAPI from "@/services/catalogos";
import transform from "@/helpers/server-side-datatable";
import { clearSwal } from "@/constants/sweet-alerts";

/**
 * State Pattern for MassUpdate form
 */
export default class MassupdateStates extends State {
  /**
   * General Methods
   */
  base() {
    return {
      clear({ $setState }) {
        $setState("initial");
      }
      , async askForClear({ $data }) {
        try {
          if ((await $data.$swal(clearSwal)).value) this.clear();
        } catch (error) {
          console.error(error);
        }
      }
      , resetModel({ $data }) {
        $data.massupdate = new Massupdate();
        $data.refreshkey += 1;
      }
      , isDisableButtonSubmit({ $data }) {
        return $data.view.action.submit.busy || !modelIsModified($data.massupdate);
      }
      , async loadSelectsData({ $data }) {
        const { data: { results: { combo: vendorList } } } = await CombosAPI.get({ option: "vendor" });
        $data.view.elem.select.vendor.filteredList = vendorList ? vendorList.filter((value) => value.status) : [];
        $data.view.elem.select.vendor.completeList = vendorList || [];
      }
      , prepareData({ $data }, data) {
        this.prepareDataVendor(data);
        this.prepareDataDatelimini(data);
        this.prepareDataDatelimend(data);
        this.prepareDataDateresini(data);
        this.prepareDataDateresend(data);
        this.prepareDataCuotasimple(data);
        this.prepareDataBenefpref(data);
        this.prepareDataContactpref(data);
        this.prepareDataOob(data);
        this.prepareDataStatus(data);

        console.log("prepareData: ", JSON.stringify($data.filters));

        let serverSideData = {};
        serverSideData.draw = "0";
        serverSideData.filters = JSON.stringify($data.filters);
        serverSideData.start = 0;
        serverSideData.length = 10;
        serverSideData.search = { value: $data.search ? $data.search : "", regex: false };
        serverSideData.order = { column: "clave", dir: "asc" };
        serverSideData.columns = $data.headers;
        return transform.transformServerSideRequest(serverSideData);
      }
      , async prepareDataVendor({ $data }, { vendor }) {
        if (vendor && vendor != "") $data.filters.updvendor = vendor;
      }
      , async prepareDataDatelimini({ $data }, { datelimini }) {
        if (datelimini && datelimini != "") $data.filters.upddatelimini = datelimini;
      }
      , async prepareDataDatelimend({ $data }, { datelimend }) {
        if (datelimend && datelimend != "") $data.filters.upddatelimend = datelimend;
      }
      , async prepareDataDateresini({ $data }, { dateresini }) {
        if (dateresini && dateresini != "") $data.filters.upddateresini = dateresini;
      }
      , async prepareDataDateresend({ $data }, { dateresend }) {
        if (dateresend && dateresend != "") $data.filters.upddateresend = dateresend;
      }
      , async prepareDataCuotasimple({ $data }, { cuotasimple }) {
        if (cuotasimple && cuotasimple != "") $data.filters.updcuotasimple = cuotasimple;
      }
      , async prepareDataBenefpref({ $data }, { benefpref }) {
        if (benefpref && benefpref != "") $data.filters.updbenefpref = benefpref;
      }
      , async prepareDataContactpref({ $data }, { contactpref }) {
        if (contactpref && contactpref != "") $data.filters.updcontactpref = contactpref;
      }
      , async prepareDataOob({ $data }, { oob }) {
        if (oob && oob != "") $data.filters.updoob = oob;
      }
      , async prepareDataStatus({ $data }, { status }) {
        if (status && status != "") $data.filters.updstatus = status;
      }
    };
  }

  /**
   * States and their methods
   */
  states() {
    return {
      initial: {
        $constructor: function ({ $data }) {
          // Reset Models
          this.resetModel();
          this.loadSelectsData();

          // View configuration buttons
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.save;
          $data.view.elem.button.submit.title.current = $data.view.elem.button.submit.title.save;
        }
        , async submit({ $data }, data) {
          try {
            $data.view.action.submit.busy = true;

            const serverSideDataT = this.prepareData(data);
            const response = await campanaAPI.massupdate(serverSideDataT);

            $data.view.action.submit.busy = false;
            this.resetModel();
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/views/operativos/campana/massupdate/massupdate-state.js